import classNames from 'classnames'
import getConfig from 'next/config'
import CustomImage from 'src/components/Image'
import { SHOPIFY_APP_INSTALL_LINK } from 'src/constants/customers'
import useI18n from 'src/hooks/use_i18n'
import { CarrierInfoMarkDTO } from 'src/types'
import { handleToShopify } from 'src/utils/tools'
import styles from './index.module.scss'

const { publicRuntimeConfig } = getConfig()

const assetPrefix = publicRuntimeConfig.assetPrefix || ''

interface Props {
  carrierInfoMark: CarrierInfoMarkDTO
}

export default function LogisticsInfo({ carrierInfoMark }: Props) {
  const { $t } = useI18n()

  const formatCarrier = (name: string) => {
    const str = name.replace('1,900+', carrierInfoMark?.partner || '2100')
    return str
  }

  const renderToShopifyBtn = () => {
    return (
      <button className="cursor-pointer" onClick={handleToShopify}>
        <a href={SHOPIFY_APP_INSTALL_LINK}>
          <span>{$t('ResWwwPTrackCenterLP.global.__section1_freeButton')}</span>
          <svg className="arrow-right" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path d="m17.707 9.293-5-5a.999.999 0 1 0-1.414 1.414l3.293 3.293h-11.586a1 1 0 1 0 0 2h11.586l-3.293 3.293a.999.999 0 1 0 1.414 1.414l5-5a.999.999 0 0 0 0-1.414z"></path>
          </svg>
        </a>
      </button>
    )
  }

  return (
    <section className={classNames(styles['logistics-info'])}>
      <h2 className={classNames(styles.title)}>{$t('ResWwwPTrackCenterLP.global.__section3_whereINTLPackageTitle')}</h2>
      <p className={styles.desc}>{$t('ResWwwPTrackCenterLP.global.__section3_whereINTLPackageDes')}</p>
      {/* 运单管理 */}
      <div className={classNames('flex items-center', styles.row)}>
        <div className={classNames('flex-1 relative', styles.cover)}>
          <CustomImage
            src={assetPrefix + '/assets/images/track_page/part3_01'}
            alt="17TRACK"
            fill
            className="lazy-image-fill"
          />
        </div>
        <div className={classNames(styles.content)}>
          <h3>{$t('ResWwwPTrackCenterLP.global.__section3_monitorTitle')}</h3>
          <ul>
            <li>{$t('ResWwwPTrackCenterLP.global.__section3_monitorDes1')}</li>
            <li>{$t('ResWwwPTrackCenterLP.global.__section3_monitorDes2')}</li>
            <li>{$t('ResWwwPTrackCenterLP.global.__section3_monitorDes3')}</li>
            <li>{formatCarrier($t('ResWwwPTrackCenterLP.global.__section3_monitorDes4'))}</li>
            <li>{$t('ResWwwPTrackCenterLP.global.__section3_monitorDes5')}</li>
          </ul>
          {renderToShopifyBtn()}
        </div>
      </div>

      {/* 品牌查询定制 - sm */}
      <div className={classNames('flex items-center relative hidden-xs', styles.row)}>
        <div className={classNames(styles.content)}>
          <h3>{$t('ResWwwPTrackCenterLP.global.__section3_customerNewTrackStatusTitle')}</h3>
          <ul>
            <li>{$t('ResWwwPTrackCenterLP.global.__section3_customerNewTrackStatusDes1')}</li>
            <li>{$t('ResWwwPTrackCenterLP.global.__section3_customerNewTrackStatusDes2')}</li>
            <li>{$t('ResWwwPTrackCenterLP.global.__section3_customerNewTrackStatusDes3')}</li>
            <li>{$t('ResWwwPTrackCenterLP.global.__section3_customerNewTrackStatusDes4')}</li>
            <li>{$t('ResWwwPTrackCenterLP.global.__section3_customerNewTrackStatusDes5')}</li>
          </ul>
          {renderToShopifyBtn()}
        </div>
        <div className={classNames('flex-1 relative', styles.cover)}>
          <CustomImage
            src={assetPrefix + '/assets/images/track_page/part3_02'}
            alt="17TRACK"
            fill
            className="lazy-image-fill"
          />
        </div>
      </div>

      {/* 品牌查询定制 - xs */}
      <div className={classNames('flex items-center hide visible-xs', styles.row)}>
        <div className={classNames('flex-1 relative', styles.cover)}>
          <CustomImage
            src={assetPrefix + '/assets/images/track_page/part3_02'}
            alt="17TRACK"
            fill
            className="lazy-image-fill"
          />
        </div>
        <div className={classNames(styles.content)}>
          <h3>{$t('ResWwwPTrackCenterLP.global.__section3_customerNewTrackStatusTitle')}</h3>
          <ul>
            <li>{$t('ResWwwPTrackCenterLP.global.__section3_customerNewTrackStatusDes1')}</li>
            <li>{$t('ResWwwPTrackCenterLP.global.__section3_customerNewTrackStatusDes2')}</li>
            <li>{$t('ResWwwPTrackCenterLP.global.__section3_customerNewTrackStatusDes3')}</li>
            <li>{$t('ResWwwPTrackCenterLP.global.__section3_customerNewTrackStatusDes4')}</li>
            <li>{$t('ResWwwPTrackCenterLP.global.__section3_customerNewTrackStatusDes5')}</li>
          </ul>
          {renderToShopifyBtn()}
        </div>
      </div>

      {/* 数据分析 */}
      <div className={classNames('flex items-center', styles.row)}>
        <div className={classNames('flex-1 relative', styles.cover)}>
          <CustomImage
            src={assetPrefix + '/assets/images/track_page/part3_03'}
            alt="17TRACK"
            fill
            className="lazy-image-fill"
          />
        </div>
        <div className={classNames(styles.content)}>
          <h3>{$t('ResWwwPTrackCenterLP.global.__section3_trackingNeedTitle')}</h3>
          <ul>
            <li>{$t('ResWwwPTrackCenterLP.global.__section3_trackingNeedDes1')}</li>
            <li>{$t('ResWwwPTrackCenterLP.global.__section3_trackingNeedDes2')}</li>
            <li>{$t('ResWwwPTrackCenterLP.global.__section3_trackingNeedDes3')}</li>
          </ul>
          {renderToShopifyBtn()}
        </div>
      </div>

      {/* 运输保险 - sm */}
      <div className={classNames('flex items-center hidden-xs', styles.row)}>
        <div className={classNames(styles.content)}>
          <h3>{$t('ResWwwPTrackCenterLP.global.__section2_dataAnalysisSelectorTitle')}</h3>
          <ul>
            <li>{$t('ResWwwPTrackCenterLP.global.__section3_highQualityDes1')}</li>
            <li>{$t('ResWwwPTrackCenterLP.global.__section3_highQualityDes2')}</li>
            <li>{$t('ResWwwPTrackCenterLP.global.__section3_highQualityDes3')}</li>
            <li>{$t('ResWwwPTrackCenterLP.global.__section3_highQualityDes4')}</li>
          </ul>
          {renderToShopifyBtn()}
        </div>
        <div className={classNames('flex-1 relative', styles.cover)}>
          <CustomImage
            src={assetPrefix + '/assets/images/track_page/part3_04'}
            alt="17TRACK"
            fill
            className="lazy-image-fill"
          />
        </div>
      </div>

      {/* 运输保险 - xs */}
      <div className={classNames('flex items-center hide visible-xs', styles.row)}>
        <div className={classNames('flex-1 relative', styles.cover)}>
          <CustomImage
            src={assetPrefix + '/assets/images/track_page/part3_04'}
            alt="17TRACK"
            fill
            className="lazy-image-fill"
          />
        </div>
        <div className={classNames(styles.content)}>
          <h3>{$t('ResWwwPTrackCenterLP.global.__section3_highQualityTitle')}</h3>
          <ul>
            <li>{$t('ResWwwPTrackCenterLP.global.__section3_highQualityDes1')}</li>
            <li>{$t('ResWwwPTrackCenterLP.global.__section3_highQualityDes2')}</li>
            <li>{$t('ResWwwPTrackCenterLP.global.__section3_highQualityDes3')}</li>
            <li>{$t('ResWwwPTrackCenterLP.global.__section3_highQualityDes4')}</li>
          </ul>
          {renderToShopifyBtn()}
        </div>
      </div>
    </section>
  )
}
